var React = require('react');

function Book (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.129 3.322h-.827V1.624a.515.515 0 00-.497-.499H3.963c-.877 0-1.588.715-1.588 1.598v10.554c0 .883.711 1.598 1.588 1.598h9.166a.498.498 0 00.496-.5V3.823c0-.276-.222-.5-.496-.5zm-4.997 5.31l-1.19-.982a.51.51 0 00-.53 0l-1.191.983V4.32h2.911v4.312zm3.177-5.31H3.963a.597.597 0 01-.595-.599c0-.33.266-.6.595-.6h7.346v1.2z"}));
}

Book.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Book;

Book.default = Book;
